// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"bdc73414","428":"338e3934","444":"dc297471","548":"beb08ed7","597":"6ee6d5ce","642":"e1f476eb","649":"054ee47f","737":"c9cfb587","882":"a9e56a79","901":"6fb9f6a3"}[chunkId] + ".chunk.css";
};